exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar {\n  width: 40px;\n  height: 40px;\n  background: #efefef;\n  line-height: 40px;\n  border-radius: 50%;\n  text-align: center;\n  overflow: hidden; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/avatar/avatar.component.scss
// module id = ../../../../../src/app/shared/components/avatar/avatar.component.scss
// module chunks = main